import React from 'react'
import { bool, node, string, oneOf, number } from 'prop-types'
import classNames from 'classnames'

import styles from './ButtonStandard.module.scss'

import ButtonBase from '../ButtonBase'
import Spinner from '../Spinner'
import Type from '../Type'
import Icon from '../Icon'

const ButtonStandard = ({
  children,
  className,
  disabled,
  loading,
  primary,
  size = 'default',
  outline,
  inverse,
  icon,
  iconFirst,
  iconWidth,
  iconHeight,
  ...other
}) => {
  const typeSizeMap = {
    default: 'heading8',
    small: ['body4', 'body4'],
    large: 'heading6',
    bloated: ['body2', 'body4']
  }
  return (
    <ButtonBase
      className={classNames(
        styles.ButtonStandard,
        disabled && styles.disabled,
        loading && styles.loading,
        primary && styles.primary,
        size && styles[size],
        outline && styles.outline,
        inverse && styles.inverse,
        className
      )}
      disabled={disabled}
      {...other}
    >
      <span
        className={classNames(
          styles.ButtonStandardContent,
          icon && styles.hasIcon,
          iconFirst && styles.reversed
        )}
      >
        <Type
          size={typeSizeMap[size]}
          weight={size === 'small' ? 'medium' : 'bold'}
          className={styles.Text}
        >
          {children}
        </Type>
        {icon && (
          <Icon
            width={iconWidth || 7}
            height={iconHeight}
            className={styles.Icon}
            type={icon}
          />
        )}
      </span>

      {loading && (
        <span className={styles.ButtonStandardSpinner}>
          <Spinner revealDelay={200} />
        </span>
      )}
    </ButtonBase>
  )
}

ButtonStandard.propTypes = {
  children: node,
  className: string,
  disabled: bool,
  loading: bool,
  primary: bool,
  size: oneOf(['default', 'small', 'large', 'bloated', 'huge']),
  outline: bool,
  inverse: bool,
  icon: string,
  iconFirst: bool,
  iconWidth: number,
  iconHeight: number,
  block: bool
}

export default ButtonStandard
